'use client';

import { useFormikContext } from 'formik';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { Type } from '../../types/Event/Type';
import { eventTypes } from '../../utils/events';
import type { EventFormValues } from './form';

type Props = {
  disabled: boolean;
};

const EventTypeSelector = ({ disabled }: Props) => {
  const { values: { eventType }, setFieldValue } = useFormikContext<EventFormValues>();

  return (
    <FormControl component="fieldset" sx={{ mb: 2 }}>
      <FormLabel component="legend" sx={{ mb: 1 }}>Event type</FormLabel>
      <ToggleButtonGroup
        value={eventType}
        exclusive
        onChange={(_e, newValue: Type | null) => {
          if (newValue !== null) {
            setFieldValue('eventType', newValue);
          }
        }}
        disabled={disabled}
        size="small"
      >
        {Object.entries(eventTypes).map(([value, { name, icon: Icon }]) => (
          <ToggleButton key={value} value={value} sx={{ display: 'flex', gap: 0.5 }}>
            <Icon fontSize="small" />
            {name}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </FormControl>
  );
};

export default EventTypeSelector;
